import { Navigate, useParams } from "react-router-dom";
import { TalentCastingBasePage, TalentDataPage, TalentDetailsPage, TalentPhotoLabBasePage } from "./LazyPages";
import { buildRoute, RoutePathEnum } from "@/routes/paths";
import { buildDepartmentRoute, getDepartmentHome } from "@/utils/department-routes";
import { useDepartmentRoute } from "@/hooks/common/use-department-route";

import { LaboratorioTalentBookPage, LaboratorioTalentsPage, TalentBookPage, TalentsPage } from "./LazyPages";

// TODO: refatorar código para considerar vários departamentos ao invés de só Laboratório

/**
 * Componentes de página condicionais para customizações específicas por departamento
 *
 * Estes componentes renderizam diferentes páginas baseado no parâmetro de departamento da URL.
 * Usados para rotas que existem em todos os departamentos mas têm implementações diferentes.
 *
 * Padrão: Rotas compartilhadas com páginas customizadas por departamento via composição.
 */

/**
 * Renderiza página customizada de talentos para Laboratório, página padrão para outros departamentos
 */
export const ConditionalTalentsPage = () => {
  const { department } = useParams<{ department: string }>();
  return department === "laboratorio" ? <LaboratorioTalentsPage /> : <TalentsPage />;
};

/**
 * Renderiza página customizada de book para Laboratório, página padrão para outros departamentos
 */
export const ConditionalTalentBookPage = () => {
  const { department } = useParams<{ department: string }>();
  return department === "laboratorio" ? <LaboratorioTalentBookPage /> : <TalentBookPage />;
};

export const ConditionalTalentBasePage = () => {
  const { department } = useParams<{ department: string }>();

  if (department === "casting") {
    return <TalentCastingBasePage />;
  }

  if (department === "laboratorio") {
    return <TalentPhotoLabBasePage />;
  }

  if (department === "fradique" || department === "reboucas") {
    return <Navigate to={buildDepartmentRoute(department, getDepartmentHome(department))} replace />;
  }

  return <Navigate to="/" replace />;
};

export const ConditionalTalentDetailsPage = () => {
  const { departmentSlug } = useDepartmentRoute();
  const { id } = useParams<{ id: string }>();

  if (departmentSlug === "laboratorio") {
    return <Navigate to={buildRoute(RoutePathEnum.TALENT_BOOK, { id: id ?? "" }, departmentSlug)} replace />;
  }

  return <TalentDetailsPage />;
};

export const ConditionalTalentDataPage = () => {
  const { departmentSlug } = useDepartmentRoute();
  const { id } = useParams<{ id: string }>();

  if (departmentSlug === "laboratorio") {
    return <Navigate to={buildRoute(RoutePathEnum.TALENT_BOOK, { id: id ?? "" }, departmentSlug)} replace />;
  }

  return <TalentDataPage />;
};
